import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { withDefaults, ref, watch, onMounted } from 'vue';
import { AlertIcon, AtomSelect, AtomTooltip } from '@/components/atoms';
import { IOptionsSelect, ITab } from '@/types';

interface IProps {
  modelValue: string;
  tabs: ITab[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTabs',
  props: {
    modelValue: { default: '' },
    tabs: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string, tabs: ITab[] };




const tab = ref(props.tabs[0].label)

function updateTab() {
  emit('update:modelValue', tab.value)
}

watch(
  () => tab.value,
  () => {
    updateTab()
  }
)
onMounted(() => {
  if (props.modelValue) tab.value = props.modelValue
})

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createBlock(_component_v_tabs, {
    modelValue: tab.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
    color: "primary",
    class: "w-100"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (itemTab) => {
        return (_openBlock(), _createBlock(_component_v_tab, {
          value: itemTab.value,
          key: itemTab.value,
          class: "text-muted text-md"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(itemTab.label), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})